import { GraphQLClient } from "graphql-request";
import { AccessToken } from "../../enums/access-token";

export const createAuthClient = () => {
  const token = localStorage.getItem(AccessToken.KEY);
  return new GraphQLClient(process.env.REACT_APP_BACKEND_API!, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
